export default [
    {
      id: 1,
      name: "100-Og",
      type: "hybrid",
      rating: 4,
      description:
        "Creative,Energetic,Tingly,Euphoric,Relaxed	Earthy,Sweet,Citrus	$100 OG is a 50/50 hybrid strain that packs a strong punch. The name supposedly refers to both its strength and high price when it first started showing up in Hollywood. As a plant, $100 OG tends to produce large dark green buds with few stems. Users report a strong body effect of an indica for pain relief with the more alert, cerebral feeling thanks to its sativa side.",
      img:
        "https://images.unsplash.com/photo-1599564576463-d038c6945bb5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    },
    {
        id: 2,
        name: "24K-Gold",
        type: "hybrid",
        rating: 4.6,
        description:
          "Happy,Relaxed,Euphoric,Uplifted,Talkative,Citrus,Earthy,Orange,Also known as Kosher Tangie, 24k Gold is a 60% indica-dominant hybrid that combines the legendary LA strain Kosher Kush with champion sativa Tangie to create something quite unique.Growing tall in its vegetative cycle and very stretchy in flower, this one will need an experienced hand when grown indoors. Most phenotypes will exhibit a sweet orange aroma from the Tangie along with the dark coloration of the Kosher Kush, and will offer a strong citrus flavor when smoked or vaped. THC levels range from 18% to 24%; definitely not for novice users!",
        img:
          "https://images.unsplash.com/photo-1556928045-16f7f50be0f3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
      },
      {
        id: 3,
        name: "Blueberry",
        type: "hybrid",
        rating: 4,
        description:
          "Uplifted,Sleepy,Happy,Relaxed,Focused,Sweet,Flowery,Pine,From Leafs by Snoop, Blueberry Dream is a sativa strain with undisclosed genetics. Likely similar to the famous Blue Dream hybrid, Blueberry Dream is said to bring out your creativity while giving the mood a boost, all with the sweet flavor of ripe blueberries. With a typical THC content of about 14%, Blueberry Dream is a good choice for beginners looking for a less jarring psychoactive experience.",
        img:
          "https://images.unsplash.com/photo-1549494093-a565e02bcfaa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
      },
      {
        id: 4,
        name: "Boss",
        type: "hybrid",
        rating: 4.4,
        description:
          "Relaxed,Happy,Euphoric,Sleepy,Uplifted,Earthy,Sweet,Pungent,Boss Hogg by Cali Connection is an indica-dominant hybrid cross between Chemdawg 4 and another Chem 4 backcross. This strainÂ carries a strong earthy, hashy aroma that mixes with the funky sour diesel notes of its Chemdawg parent. A true hybrid, Boss HoggÂ delivers a balance of mind and body effects that ease the body into relaxation while the mind is lifted to a happy, euphoric state. Despite its heavy body effects, Boss Hogg is cerebrally stimulating and sharpens the senses to help you stay engaged and creative.",
        img:
          "https://images.unsplash.com/photo-1518292806887-e50c8ca5a844?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
      },];

  

